module.exports = __webpack_public_path__ + "img/l10.e2faa1aa.jpg";